module.exports = __webpack_public_path__ + "img/10.0efc3b75.jpg";